package com.eladfinish.bible.contest.features.teruma

data class AboutTerumaUiModel(
    val text: String,
    val ctaText: String,
    val url: String,
)
